export default {
    name: 'Name',
    last_name: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    price: 'Price',
    total_price: 'Total price',
    nights: 'Nights',
    choose_period: 'Choose period',
    check_in: 'Check In',
    check_out: 'Check Out',
    number_of_nights: 'Number of nights',
    accept_terms: 'Accept terms and conditions',
    reserve_now: 'Reserve now',
    buy_now: 'Buy now',
}
